module.exports = __webpack_public_path__ + "static/img/8c310be7.png";